// Maps the /beers/analytics/:restaurant API response into the props expected by
// BeerDashboardStats. Shared by Manage Menu (menu-items-table) and the
// Manage Restaurants side panel so Beer analytics has a single definition.
export const mapBeerAnalyticsToStats = (api, fallbackTotal = 0) => {
  const total = api?.totalBeers || fallbackTotal || 0;

  const BeerCategory = (api?.categoryDistribution || [])
    .map((c) => ({
      label: c.name,
      value: c.percentage || 0,
      count: c.count || 0,
    }))
    .sort((a, b) => b.value - a.value);

  const regionalDistribution = Object.entries(api?.regions || {})
    .map(([label, value]) => ({ label, value: Number(value || 0) }))
    .sort((a, b) => b.value - a.value);

  const activeBeersCount = api?.activeBeersCount ?? total;
  const dietaryConsiderations = Object.entries(api?.characteristics || {}).map(
    ([label, count]) => ({
      label,
      count: count || 0,
      value:
        activeBeersCount > 0
          ? `${Math.round((count / activeBeersCount) * 100)}%`
          : "0%",
    })
  );

  const normalizedRecent = (api?.recentUpdates || []).map((u) => ({
    type: u.action,
    text: u.details?.description || u.details?.beer_uuid,
    user: u.user_uuid
      ? `${u.user_uuid.first_name || ""} ${u.user_uuid.last_name || ""}`.trim()
      : undefined,
    createdAt: u.createdAt,
  }));

  return {
    total,
    newBeers: api?.newBeersInThirtyDays || 0,
    removed: api?.removedBeersInThirtyDays || 0,
    lastUpdated: api?.lastUpdatedBeer || "",
    BeerCategory,
    styleDistribution: api?.styleDistribution || [],
    topVarietals: [],
    regionalDistribution,
    dietaryConsiderations,
    recentUpdates: normalizedRecent,
  };
};
